import { useState } from 'react'
import { CS_URL } from '../constants'
import { DesktopNav } from './desktop-nav'
import { MobileNav } from './mobile-nav'

export const Header = () => {
    const [desktopNavOpen, setDesktopNavOpen] = useState(false)
    const setDesktopNavState = (isOpen: boolean) => {
        setDesktopNavOpen(isOpen)
    }

    const [mobileNavOpen, setMobileNavOpen] = useState(false)
    const closeMobileNav = () => {
        setMobileNavOpen(false)
    }

    return (
        <header className="cs-site-header">
            <div className="cs-navigation-wrapper">
                <div
                    className="cs-bgnav-open-button"
                    onClick={() => {
                        setMobileNavOpen(true)
                    }}>
                    <span className="icon">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            xmlnsXlink="http://www.w3.org/1999/xlink"
                            width="74.211"
                            height="43.225"
                            viewBox="0 0 74.211 43.225">
                            <defs>
                                <style>
                                    {`
                            .a,
                            .c,
                            .d {
                                fill: none;
                                stroke-width: 2px;
                            }

                            .a {
                                stroke: #707070;
                            }

                            .b {
                                clip-path: url(#a);
                            }

                            .c,
                            .d {
                                stroke: #fff;
                            }

                            .d {
                                stroke-miterlimit: 10;
                            }`}
                                </style>
                                <clipPath id="a">
                                    <rect
                                        className="a"
                                        width="41.201"
                                        height="38.288"
                                        transform="translate(897 145.712)"
                                    />
                                </clipPath>
                            </defs>
                            <g transform="translate(-863.991 -145.712)">
                                <g className="b">
                                    <path
                                        className="c"
                                        d="M913.339,177.042a14.99,14.99,0,1,0-14.992-14.989A14.994,14.994,0,0,0,913.339,177.042Z"
                                    />
                                    <line
                                        className="c"
                                        x2="12.827"
                                        y2="11.547"
                                        transform="translate(924.47 171.452)"
                                    />
                                </g>
                                <line
                                    className="d"
                                    x2="27.009"
                                    transform="translate(863.991 157.306)"
                                />
                                <line
                                    className="d"
                                    x2="27.009"
                                    transform="translate(863.991 172.622)"
                                />
                                <line
                                    className="d"
                                    x2="49.009"
                                    transform="translate(863.991 187.937)"
                                />
                            </g>
                        </svg>
                    </span>
                </div>

                <div
                    className={`nav-background js-nav-background ${
                        desktopNavOpen ? '' : 'is-hidden'
                    }`}></div>
                <div className="cs-main-nav-wrapper nav-wrapper js-nav-wrapper">
                    <a id="p_lt_ctl00_CS_MainNavigation_hypSiteURL" href="/">
                        <img
                            id="p_lt_ctl00_CS_MainNavigation_imgLogo"
                            className="cs-site-header-logo"
                            src="https://cs-aws-uks-static-fqcbhahmb9d6bcg2.a02.azurefd.net/logos/citySprint-logo.png"
                            alt="CS.MainLogoAltText"
                        />
                    </a>
                    <DesktopNav onStateChange={setDesktopNavState} />
                    {mobileNavOpen && <MobileNav onClose={closeMobileNav} />}
                    <div
                        id="p_lt_ctl00_CS_MainNavigation_PnlHeaderBtnWrap"
                        className="cs-header-button-wrap">
                        <div className="cs-cta-buttons">
                            <a
                                id="p_lt_ctl00_CS_MainNavigation_hyperLink1"
                                className="cs-secondary-button"
                                href={`${CS_URL}/couriers`}>
                                Become a courier
                            </a>
                            <a
                                id="p_lt_ctl00_CS_MainNavigation_hyperLink2"
                                className="cs-secondary-button"
                                href="https://my.citysprint.co.uk/s/company-registration">
                                <span className="icon">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="22"
                                        height="22"
                                        viewBox="0 0 22 22">
                                        <defs>
                                            <style>
                                                {`
                                        .user-icon {
                                            fill: #f0f6f9;
                                            stroke: #0194d3;
                                        }`}
                                            </style>
                                        </defs>
                                        <g transform="translate(0.5 0.5)">
                                            <g transform="translate(-1560.645 -109.5)">
                                                <circle
                                                    className="user-icon"
                                                    cx="10.5"
                                                    cy="10.5"
                                                    r="10.5"
                                                    transform="translate(1560.645 109.5)"
                                                />
                                                <circle
                                                    className="user-icon"
                                                    cx="4.45"
                                                    cy="4.45"
                                                    r="4.45"
                                                    transform="translate(1566.695 113.5)"
                                                />
                                            </g>
                                            <path
                                                className="user-icon"
                                                d="M1563.72,127.575a10.5,10.5,0,0,1,14.773-.075"
                                                transform="translate(-1560.645 -109.5)"
                                            />
                                        </g>
                                    </svg>
                                </span>
                                Sign up for an account
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </header>
    )
}
